export default {
    GET_LIST_ORDER: 'GET_LIST_ORDER',
    CHANGE_ORDER_STATUS_TO_SHIPPING: 'CHANGE_ORDER_STATUS_TO_SHIPPING',
    CANCEL_LIST_ORDER: 'CANCEL_LIST_ORDER',
    CHANGE_ORDER_STATUS_TO_PACKING: 'CHANGE_ORDER_STATUS_TO_PACKING',
};